import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CONSTANTS } from 'src/app/core/constants/constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-simulation-uploader',
  templateUrl: './simulation-uploader.component.html',
  styleUrls: ['./simulation-uploader.component.scss'],
})
export class SimulationUploaderComponent {
  @Input() disabled: boolean;
  @Output() selected = new EventEmitter<any>();
  @ViewChild('fileField') fileSelector;

  acceptedFiles: string;
  hasSelectedFile: boolean;
  fileName: string;

  constructor() {
    const extArray = [CONSTANTS.AML_UPLOAD_EXT, CONSTANTS.JSON_UPLOAD_EXT];
    this.acceptedFiles = environment.production ? extArray[1] : extArray.join(', ');
  }

  newFile(event): void {
    this.hasSelectedFile = true;
    this.fileName = event.target.files[0].name;
    this.selected.emit(event);
    this.fileSelector.nativeElement.value = '';
  }

  resetFiles(): void {
    this.hasSelectedFile = false;
    delete this.fileName;
    this.selected.emit(null);
  }
}
